exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup-content {\n  font-family: Arial, sans-serif;\n  font-size: 13px; }\n  .popup-content, .popup-content .entry {\n    padding-bottom: 6px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden; }\n  .popup-content button.details-link {\n    width: 100%;\n    display: block;\n    text-align: left;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    border-radius: 0;\n    outline: 0;\n    vertical-align: baseline;\n    background: transparent;\n    list-style: none;\n    overflow: visible; }\n    .popup-content button.details-link:hover, .popup-content button.details-link:focus {\n      color: #4285F4; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/SPA/src/app/client/serviceObject/map/popup/service-object-popup.component.scss
// module id = ../../../../../src/app/client/serviceObject/map/popup/service-object-popup.component.scss
// module chunks = 0